const FaqsSection = ({ name }) => {
  return (
    <section className="max-w-6xl mx-auto px-6 py-16 transition-colors duration-300 bg-[#f9fafb] dark:bg-[#1e2430]">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-start">
        {/* ---------- Left Side: FAQ Intro ---------- */}
        <div className="text-left">
          <p className="text-sm text-gray-500 dark:text-gray-400 font-medium mb-2">
            FAQ section
          </p>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 dark:text-white mb-4 leading-tight">
            Frequently asked questions <br /> about {name} Casino
          </h2>
          <p className="text-gray-600 dark:text-gray-300 leading-relaxed">
            We’ve compiled the most important information to help you get the
            most out of your experience. Can’t find what you’re looking for?{" "}
            <a
              href="/contact"
              className="text-blue-600 dark:text-blue-400 hover:underline font-medium"
            >
              Contact us.
            </a>
          </p>
        </div>

        {/* ---------- Right Side: Questions ---------- */}
        <div className="text-left">
          <h3 className="text-lg font-semibold text-gray-800 dark:text-gray-100 mb-4">
            General
          </h3>

          <div
            className="border border-gray-300 dark:border-gray-600 
            rounded-2xl p-8 
            bg-white dark:bg-[#1e2430]
            text-gray-800 dark:text-gray-200
            transition-colors duration-300"
          >
            <details className="py-4 group">
              <summary className="cursor-pointer text-gray-900 dark:text-gray-100 font-medium flex justify-between items-center">
                <span>Is {name} Casino legit?</span>
                <span className="transition-transform group-open:rotate-180">
                  ▼
                </span>
              </summary>
              <p className="mt-2 text-gray-700 dark:text-gray-300 text-sm leading-relaxed">
                Yes, {name} Casino operates under a valid license and ensures
                fair play and data protection for all players.
              </p>
            </details>

            <details className="py-4 group">
              <summary className="cursor-pointer text-gray-900 dark:text-gray-100 font-medium flex justify-between items-center">
                <span>
                  How long does it take to process withdrawals at {name} Casino?
                </span>
                <span className="transition-transform group-open:rotate-180">
                  ▼
                </span>
              </summary>
              <p className="mt-2 text-gray-700 dark:text-gray-300 text-sm leading-relaxed">
                Withdrawals are typically processed within 24 hours, depending
                on your chosen payment method.
              </p>
            </details>

            <details className="py-4 group">
              <summary className="cursor-pointer text-gray-900 dark:text-gray-100 font-medium flex justify-between items-center">
                <span>Does {name} offer a no deposit bonus?</span>
                <span className="transition-transform group-open:rotate-180">
                  ▼
                </span>
              </summary>
              <p className="mt-2 text-gray-700 dark:text-gray-300 text-sm leading-relaxed">
                Occasionally, {name} Casino offers no deposit bonuses during
                promotions. Keep an eye on the promotions page.
              </p>
            </details>

            <details className="py-4 group">
              <summary className="cursor-pointer text-gray-900 dark:text-gray-100 font-medium flex justify-between items-center">
                <span>Is {name} available in the UK?</span>
                <span className="transition-transform group-open:rotate-180">
                  ▼
                </span>
              </summary>
              <p className="mt-2 text-gray-700 dark:text-gray-300 text-sm leading-relaxed">
                {name} Casino operates in multiple regions, but availability
                depends on local licensing and regulations.
              </p>
            </details>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FaqsSection;
